/* cspell:disable */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable max-lines */
export const appV2EventPrefix = "HCF Admin Web App (V2):";
const SKILLS_ASSESSMENTS_PREFIX = "Skills Assessments";
const FACILITY_RULES_AI_PREFIX = "Facility Rules AI";
const HOME_HEALTH_EVENT_PREFIX = "Home Health";
const FACILITY_INVOICE_HISTORY_EVENT_PREFIX = "Facility Invoice History";
const INVOICE_DISPUTE_EVENT_PREFIX = "Invoice Dispute";
const ZENDESK_DOCUMENT_PROCESSOR_PREFIX = "Zendesk Document Processor:";
const AGENT_DRAWER_DOCUMENT_REVIEW_PREFIX = "Agent Drawer Document Review:";
const SHIFT_TIME_PROPOSALS_PREFIX = "Shift Time Proposals";
const CBH_LITE_TRIAL_PREFIX = "CBH Lite Trial";
const FACILITY_DASHBOARD_PREFIX = "Facility Dashboard";
const EDIT_CHARGE_RATE_PREFIX = "Edit Charge Rate";
const REQUIREMENTS_BANNER_PREFIX = "Requirements Banner";
const EXTERNAL_WORKPLACE_PHOTOS_PREFIX = "External Workplace Photos";

export const APP_V2_USER_EVENTS = {
  // SMS Portal
  SMS_PORTAL_PAGE_VIEWED: `${appV2EventPrefix} SMS Portal page viewed`,
  SMS_PORTAL_CONVERSATION_OPENED: `${appV2EventPrefix} SMS Portal conversation opened`,
  SMS_PORTAL_MESSAGE_SENT: `${appV2EventPrefix} SMS Portal message sent`,
  SMS_PORTAL_MESSAGE_SEND_FAILED: `${appV2EventPrefix} SMS Portal message send failed`,
  SMS_PORTAL_INBOX_SEARCHED: `${appV2EventPrefix} SMS Portal inbox searched`,

  // Worker Invitations
  WORKER_INVITATION_DIALOG_ACTIONED: `${appV2EventPrefix} Worker invitation dialog actioned`,
  FAILED_TO_SKIP_WORKER_INVITATION_ONBOARDING_STEP: `${appV2EventPrefix} Failed to skip worker invitation onboarding step`,
  SKIPPED_WORKER_INVITATION_ONBOARDING_STEP: `${appV2EventPrefix} Skipped worker invitation onboarding step`,

  // Skills Assessments
  SKILLS_ASSESSMENTS_PAGE_VIEWED: `${appV2EventPrefix} ${SKILLS_ASSESSMENTS_PREFIX} page viewed`,
  SKILLS_ASSESSMENTS_FETCHED: `${appV2EventPrefix} ${SKILLS_ASSESSMENTS_PREFIX} assessments fetched`,
  SKILLS_ASSESSMENTS_GRADED: `${appV2EventPrefix} ${SKILLS_ASSESSMENTS_PREFIX} assessment graded`,

  // Booking Reqests
  BOOKING_REQUEST_ACCEPTED: `${appV2EventPrefix} Booking request accepted`,

  // Exclusion Candidates
  EXCLUSION_CANDIDATE_BANNER_SHOWN: `${appV2EventPrefix} Exclusion candidate banner shown`,
  EXCLUSION_CANDIDATE_DISMISSED: `${appV2EventPrefix} Exclusion candidate dismissed`,

  // Edit Charge Rate
  EDIT_CHARGE_RATE_WAIT_AND_SAVE_SUBMIT_CLICKED: `${appV2EventPrefix} ${EDIT_CHARGE_RATE_PREFIX} Wait and Save submit clicked`,
  EDIT_CHARGE_RATE_FLAT_RATE_SUBMIT_CLICKED: `${appV2EventPrefix} ${EDIT_CHARGE_RATE_PREFIX} Flat Rate submit clicked`,
  EDIT_CHARGE_RATE_VARIABLE_CHARGE_SUBMIT_CLICKED: `${appV2EventPrefix} ${EDIT_CHARGE_RATE_PREFIX} Variable Charge submit clicked`,
  EDIT_CHARGE_RATE_MODAL_OPENED: `${appV2EventPrefix} ${EDIT_CHARGE_RATE_PREFIX} Modal opened`,
  EDIT_CHARGE_RATE_VARIABLE_CHARGE_MODAL_OPENED: `${appV2EventPrefix} ${EDIT_CHARGE_RATE_PREFIX} Variable Charge Modal opened`,
  EDIT_CHARGE_RATE_WAIT_AND_SAVE_MODAL_OPENED: `${appV2EventPrefix} ${EDIT_CHARGE_RATE_PREFIX} Wait and Save Modal opened`,
  EDIT_CHARGE_RATE_SUBMITTED: `${appV2EventPrefix} ${EDIT_CHARGE_RATE_PREFIX} Submitted`,

  // CBH Lite Trial
  CBH_LITE_TRIAL_BANNER_VIEWED: `${appV2EventPrefix} ${CBH_LITE_TRIAL_PREFIX} Banner Viewed`,
  CBH_LITE_TRIAL_REQUEST_SUBMITTED: `${appV2EventPrefix} ${CBH_LITE_TRIAL_PREFIX} Request Submitted`,

  // Facility Dashboard
  FACILITY_DASHBOARD_BANNERS_VIEWED: `${appV2EventPrefix} ${FACILITY_DASHBOARD_PREFIX} Banners Viewed`,
  WINTER_STORM_BANNER_VIEWED: `${appV2EventPrefix} ${FACILITY_DASHBOARD_PREFIX} Winter Storm Banner Viewed`,
  WINTER_STORM_BANNER_VARIABLE_CHARGE_TOGGLED: `${appV2EventPrefix} ${FACILITY_DASHBOARD_PREFIX} Winter Storm Banner Variable Charge Toggled`,
  REQUIREMENTS_BANNER_CONTACT_CLICKED: `${appV2EventPrefix} ${REQUIREMENTS_BANNER_PREFIX} Contact clicked`,
  REQUIREMENTS_BANNER_DISMISSED: `${appV2EventPrefix} ${REQUIREMENTS_BANNER_PREFIX} Dismissed`,
  REQUIRED_DOCUMENTS_SEARCHED: `${appV2EventPrefix} Required Documents Searched`,
  REQUIRED_DOCUMENTS_QUALIFICATION_FILTER_CHANGED: `${appV2EventPrefix} Required Documents Qualification filter changed`,
  REQUIRED_DOCUMENTS_UPDATE_SUBMITTED: `${appV2EventPrefix} Required Documents Update Submitted`,
  CREATE_MULTIPLE_SHIFTS_INFO_MODAL_CTA_CLICKED: `${appV2EventPrefix} Create Multiple Shifts Info Modal CTA Clicked`,

  // Request to Book Toggle
  REQUEST_TO_BOOK_TOGGLE_CONFIRMED_ENABLED: `${appV2EventPrefix} Request to book toggle confirmed enabled`,
  REQUEST_TO_BOOK_TOGGLE_CONFIRMED_DISABLED: `${appV2EventPrefix} Request to book toggle confirmed disabled`,
  REQUEST_TO_BOOK_TOGGLE_CANCELLED_ENABLED: `${appV2EventPrefix} Request to book toggle cancelled enabled`,
  REQUEST_TO_BOOK_TOGGLE_CANCELLED_DISABLED: `${appV2EventPrefix} Request to book toggle cancelled disabled`,

  // Facility Rules AI
  FACILITY_RULES_AI_VISITED: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} page visited`,
  FACILITY_RULES_AI_REVIEW_QUIZ_BANNER_SHOWN: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} review quiz banner shown`,
  FACILITY_RULES_AI_QUIZ_REVIEWED: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} quiz reviewed`,
  FACILITY_RULES_AI_NOTES_UPDATED: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} notes updated`,
  FACILITY_RULES_AI_QUIZ_UPDATED: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} quiz updated`,
  FACILITY_RULES_AI_QUIZ_UPDATE_CANCEL_CLICKED: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} quiz update cancel clicked`,
  FACILITY_RULES_AI_QUIZ_UPDATE_CONTINUE_CLICKED: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} quiz update continue clicked`,
  FACILITY_RULES_AI_QUIZ_TOGGLED: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} quiz toggled`,
  FACILITY_RULES_AI_QUIZ_DRAWER_CLOSED: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} quiz drawer closed`,

  FACILITY_RULES_AI_QUIZ_QUESTION_TEXT_REMOVED: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} quiz question text removed`,
  FACILITY_RULES_AI_QUIZ_OPTION_TEXT_REMOVED: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} quiz option text removed`,
  FACILITY_RULES_AI_NOTES_CHARACTER_OUT_OF_RANGE_WARNING: `${appV2EventPrefix} ${FACILITY_RULES_AI_PREFIX} notes character out of range warning`,

  // Help Center
  HELP_CENTER_PAGE_VIEWED: `${appV2EventPrefix} Help Center page viewed`,
  HELP_CENTER_ARTICLE_OPENED: `${appV2EventPrefix} Help Center article opened`,
  HELP_CENTER_EXTERNAL_LINK_CLICKED: `${appV2EventPrefix} Help Center external link clicked`,

  // Home Health
  HOME_HEALTH_CASE_CREATED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} case created`,
  HOME_HEALTH_CASE_UPDATED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} case updated`,
  HOME_HEALTH_CASE_CLOSED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} case closed`,
  HOME_HEALTH_CASE_REOPENED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} case reopened`,
  HOME_HEALTH_PATIENT_CREATED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} patient created`,
  HOME_HEALTH_PATIENT_UPDATED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} patient updated`,
  HOME_HEALTH_VISIT_CREATED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit created`,
  HOME_HEALTH_VISIT_CREATED_WITH_CASE: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit created with case`,
  HOME_HEALTH_VISIT_CREATED_AFTER_CASE: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit created after case`,
  HOME_HEALTH_VISIT_UPDATED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit updated`,
  HOME_HEALTH_VISIT_CANCELED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit canceled`,
  HOME_HEALTH_VISIT_WORKER_INVITED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit worker invited`,
  HOME_HEALTH_VISIT_WORKER_BOOKED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit worker booked`,
  HOME_HEALTH_VISIT_WORKER_REMOVED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit worker removed`,
  HOME_HEALTH_VISIT_OCCURRENCE_REJECTED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit occurrence rejected`,
  HOME_HEALTH_VISIT_OCCURRENCE_VERIFIED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit occurrence verified`,
  HOME_HEALTH_VISIT_OCCURRENCE_UPDATED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit occurrence updated`,
  HOME_HEALTH_VISIT_OCCURRENCE_PAID: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit occurrence set paid`,
  HOME_HEALTH_VISIT_OCCURRENCE_NOT_PAID: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit occurrence set not paid`,
  HOME_HEALTH_VISIT_LIFECYCLE_TRACKER_VIEWED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} visit lifecycle tracker viewed`,
  HOME_HEALTH_ACCOUNT_PRICING_CREATED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} account pricing created`,
  HOME_HEALTH_ACCOUNT_PRICING_UPDATED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} account pricing updated`,
  HOME_HEALTH_ACCOUNT_PRICING_DELETED: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} account pricing deleted`,
  HOME_HEALTH_GET_WORKER_STATUS_FOR_VISIT_FAILURE: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} get worker status for visit failure`,

  // Facility Invoice History Page
  INVOICE_HISTORY_VIEWED: `${appV2EventPrefix} ${FACILITY_INVOICE_HISTORY_EVENT_PREFIX} Invoice History Viewed`,
  INVOICE_VIEW_CLICKED: `${appV2EventPrefix} ${FACILITY_INVOICE_HISTORY_EVENT_PREFIX} Invoice View Clicked`,
  INVOICE_PAY_CLICKED: `${appV2EventPrefix} ${FACILITY_INVOICE_HISTORY_EVENT_PREFIX} Clicked to Pay Invoice`,
  INVOICE_VIEW_DISPUTE_CLICKED: `${appV2EventPrefix} ${FACILITY_INVOICE_HISTORY_EVENT_PREFIX} Invoice View Dispute Button Clicked`,
  ACCOUNT_STATEMENT_DOWNLOAD_CLICKED: `${appV2EventPrefix} ${FACILITY_INVOICE_HISTORY_EVENT_PREFIX} Account Statement Download Clicked`,
  ACCOUNT_STATEMENT_DOWNLOAD_SUCCESS: `${appV2EventPrefix} ${FACILITY_INVOICE_HISTORY_EVENT_PREFIX} Account Statement Download Success`,
  ACCOUNT_STATEMENT_DOWNLOAD_FAILURE: `${appV2EventPrefix} ${FACILITY_INVOICE_HISTORY_EVENT_PREFIX} Account Statement Download Failure`,

  // Facility Upcoming Charges
  UPCOMING_CHARGES_VIEWED: `${appV2EventPrefix} Upcoming Charges Viewed`,
  UPCOMING_CHARGES_DATE_RANGE_CHANGED: `${appV2EventPrefix} Upcoming Charges Dates Changed`,
  UPCOMING_CHARGES_VERIFY_SHIFT_POPUP_OPENED: `${appV2EventPrefix} Upcoming Charges Verify Shift Popup Opened`,
  UPCOMING_CHARGES_VERIFY_SHIFT_BUTTON_CLICKED: `${appV2EventPrefix} Upcoming Charges Verify Shift Button Clicked`,
  REPORTING_VIEWED: `${appV2EventPrefix} Reporting page viewed`,

  // Invoice Dispute
  INVOICE_DISPUTE_BUTTON_CLICKED: `${appV2EventPrefix} ${INVOICE_DISPUTE_EVENT_PREFIX} Invoice Dispute Button Clicked`,
  INVOICE_DISPUTE_DRAFT_SAVED: `${appV2EventPrefix} ${INVOICE_DISPUTE_EVENT_PREFIX} Invoice Item Dispute Draft Saved`,
  INVOICE_ITEM_DISPUTE_DISCARD_BUTTON_CLICKED: `${appV2EventPrefix} ${INVOICE_DISPUTE_EVENT_PREFIX} Invoice Item Discard Button Clicked`,
  INVOICE_DISPUTE_DISCARD_ALL_BUTTON_CLICKED: `${appV2EventPrefix} ${INVOICE_DISPUTE_EVENT_PREFIX} Invoice Dispute Discard All Button Clicked`,
  INVOICE_DISPUTE_SUBMITTED: `${appV2EventPrefix} ${INVOICE_DISPUTE_EVENT_PREFIX} Invoice Dispute Submitted`,
  INVOICE_DISPUTE_UPDATED_HOURS_PREFERENCE: `${appV2EventPrefix} ${INVOICE_DISPUTE_EVENT_PREFIX} updated dispute time preferences`,
  INVOICE_DISPUTE_BLOCK_NAVIGATION_TRIGGERED: `${appV2EventPrefix} ${INVOICE_DISPUTE_EVENT_PREFIX} block navigation triggered`,
  INVOICE_DISPUTE_HOURS_FORMAT_TOOLTIP_CLOSED: `${appV2EventPrefix} ${INVOICE_DISPUTE_EVENT_PREFIX} hours format tooltip closed`,

  // Shift Block
  SHIFT_BLOCK_CREATED: `${appV2EventPrefix} Shift Block Created`,
  SHIFT_BLOCK_DELETED: `${appV2EventPrefix} Shift Block Deleted`,
  SHIFT_BLOCK_UPDATED: `${appV2EventPrefix} Shift Block Updated`,
  SHIFT_BLOCKS: `${appV2EventPrefix} Shift Blocks`,

  // Orientation Block
  ORIENTATION_BLOCK_CREATED: `${appV2EventPrefix} Orientation Block Created`,
  ORIENTATION_BLOCK_DELETE_BLOCK_CLICKED: `${appV2EventPrefix} Delete Orientation Block Clicked`,
  ORIENTATION_BLOCK_DELETED: `${appV2EventPrefix} Orientation Block Deleted`,
  ORIENTATION_BLOCKS: `${appV2EventPrefix} Orientation Blocks`,

  // Single Orientation Shifts
  ORIENTATION_SHIFT_CREATED: `${appV2EventPrefix} Orientation Shift Created`,

  // Facility Notes
  WORKER_INSTRUCTIONS_VIEWED: `${appV2EventPrefix} Worker Instructions Viewed`,
  SAVE_FACILITY_RULES_CLICKED: `${appV2EventPrefix} Save facility rules button clicked`,

  // Billing Alerts
  FACILITY_PENDING_NOTICE_ENABLED: `${appV2EventPrefix} Pending notice enabled`,
  FACILITY_SUBMIT_PAYMENT_ALERT_CTA_CLICKED: `${appV2EventPrefix} Submit payment alert CTA clicked`,
  FACILITY_LEARN_MORE_LINK_CLICKED: `${appV2EventPrefix} Learn more link clicked`,

  // Documents
  WORKER_DOCUMENTS_PAGE_VIEWED: `${appV2EventPrefix} Worker documents page viewed`,
  WORKER_DOCUMENTS_PAGE_ACTIONS: `${appV2EventPrefix} Worker documents page actions`,
  WORKER_DOCUMENTS_DOWNLOAD_ALERT_TRIGGERED: `${appV2EventPrefix} Worker document download alert triggered`,
  WORKER_DOCUMENTS_UPDATE_REQUIREMENTS_LINK_CLICKED: `${appV2EventPrefix} Worker document update requirements link clicked`,
  WORKER_DOCUMENTS_WORKER_INFO_COPIED: `${appV2EventPrefix} Worker documents worker info copied`,

  // Placement Candidates Admin events
  ADMIN_PLACEMENT_CANDIDATE_VIEWED: `${appV2EventPrefix} Admin placement candidate viewed`,
  ADMIN_PLACEMENT_CANDIDATE_UPDATED: `${appV2EventPrefix} Admin placement candidate updated`,
  ADMIN_PLACEMENT_CANDIDATE_RESUME_UPLOADED: `${appV2EventPrefix} Admin placement candidate resume uploaded`,
  ADMIN_PLACEMENT_CANDIDATE_PASSPORT_ENQUEUED: `${appV2EventPrefix} Admin placement candidate passport creation enqueued`,
  ADMIN_PLACEMENT_CANDIDATE_SCREENING_STATUS_UPDATED: `${appV2EventPrefix} Admin placement candidate screening status updated`,

  // Placement Candidates Hire Professionals page events
  PLACEMENT_CANDIDATES_BLOCKED_LIST_CARD_ACTION: `${appV2EventPrefix} Placement candidates blocked list card action`,

  // Placement Candidates Hire Professionals page events
  PLACEMENT_CANDIDATES_PAGE_VIEWED: `${appV2EventPrefix} Placement candidates page viewed`,
  PLACEMENT_CANDIDATES_PAGE_FILTER_CHANGED: `${appV2EventPrefix} Placement candidates page filter changed`,
  PLACEMENT_CANDIDATES_TILE_ACTION: `${appV2EventPrefix} Placement candidates tile action`,
  PLACEMENT_CANDIDATES_LOAD_MORE_CLICKED: `${appV2EventPrefix} Placement candidates load more clicked`,
  PLACEMENT_CANDIDATES_CONTACT_INFO_COPIED: `${appV2EventPrefix} Placement candidates contact info copied`,
  PLACEMENT_CANDIDATES_BOOKMARK_TOGGLED: `${appV2EventPrefix} Placement candidates bookmark toggled`,
  PLACEMENT_CANDIDATES_BLOCK_CANDIDATE_TOGGLED: `${appV2EventPrefix} Placement candidates block candidate toggled`,

  // Placement Candidates Details page events
  PLACEMENT_CANDIDATE_DETAILS_VIEWED: `${appV2EventPrefix} Placement candidate details page viewed`,
  PLACEMENT_CANDIDATE_DETAILS_ACTION: `${appV2EventPrefix} Placement candidate details page action`,
  PLACEMENT_CANDIDATE_SHARE_PROFILE_SUBMITTED: `${appV2EventPrefix} Placement candidate details share profile submitted`,

  PLACEMENT_CANDIDATE_CREDENTIALS_VIEW_ALL_CLICKED: `${appV2EventPrefix} Placement candidate credentials view all clicked`,
  PLACEMENT_CANDIDATE_CREDENTIAL_VIEWED: `${appV2EventPrefix} Placement candidate credential viewed`,
  PLACEMENT_CANDIDATE_CREDENTIAL_ACTION: `${appV2EventPrefix} Placement candidate credential action`,
  PLACEMENT_CANDIDATE_GET_IN_TOUCH_FORM_ACTION: `${appV2EventPrefix} Placement candidate get in touch form action`,
  PLACEMENT_CANDIDATE_CHAT_ACTION: `${appV2EventPrefix} Placement candidate chat action`,

  // Placement create and update events
  PLACEMENT_PAGE_VIEWED: `${appV2EventPrefix} Placement page viewed`,
  PLACEMENT_CREATED: `${appV2EventPrefix} Placement created`,
  PLACEMENT_UPDATED: `${appV2EventPrefix} Placement updated`,
  PLACEMENT_ACTIONS: `${appV2EventPrefix} Placement actions`,
  PLACEMENT_STATUS_CHANGE_CONFIRMED: `${appV2EventPrefix} Placement status change confirmed`,
  PLACEMENT_STATUS_CHANGE_CANCELLED: `${appV2EventPrefix} Placement status change cancelled`,

  // Placement Candidate book interview
  PLACEMENT_CANDIDATE_BOOK_INTERVIEW_FROM_CHAT: `${appV2EventPrefix} Placement candidate book interview from chat`,
  PLACEMENT_INTERVIEW_REQUESTED_NON_INSTANT_BOOK_EASY_SCHEDULING: `${appV2EventPrefix} Placement interview requested with non-instant book easy scheduling`,

  // Manage Jobs Tabs
  MANAGE_JOBS_TAB_CHANGED: `${appV2EventPrefix} Manage jobs tab changed`,

  // Placement Applications
  PLACEMENT_APPLICATIONS_PAGE_VIEWED: `${appV2EventPrefix} Placement applications page viewed`,
  PLACEMENT_APPLICATION_STATUS_UPDATED: `${appV2EventPrefix} Placement application status updated`,
  PLACEMENT_APPLICATION_CARD_ACTION: `${appV2EventPrefix} Placement application card action`,

  // Interviews
  INTERVIEWS_PAGE_VIEWED: `${appV2EventPrefix} Interviews page viewed`,
  CANCEL_INTERVIEW_DIALOG_OPENED: `${appV2EventPrefix} Cancel interview dialog opened`,
  CANCEL_INTERVIEW_DIALOG_CLOSED: `${appV2EventPrefix} Cancel interview dialog closed`,
  INTERVIEW_CANCELLED: `${appV2EventPrefix} Interview cancelled`,
  RESCHEDULE_INTERVIEW_DIALOG_OPENED: `${appV2EventPrefix} Reschedule interview dialog opened`,
  RESCHEDULE_INTERVIEW_DIALOG_CLOSED: `${appV2EventPrefix} Reschedule interview dialog closed`,
  INTERVIEW_RESCHEDULED: `${appV2EventPrefix} Interview rescheduled`,

  // Shift invite
  SHIFT_INVITE_CUSTOM_RATE_SUPPORT_LINK_CLICKED: `${appV2EventPrefix} Shift invite custom rate support link clicked`,

  // Attendance Score
  ATTENDANCE_SCORE_RESTRICTION_DELETED: `${appV2EventPrefix} Attendance score restriction deleted`,

  // Shift Signing Out
  FEEDBACK_ON_HCP_WORK_QUALITY: `${appV2EventPrefix} Work quality feedback`,
  FEEDBACK_PAGE_OPENED: `${appV2EventPrefix} Feedback page opened`,

  // Interview Settings
  INTERVIEW_SETTINGS_PAGE_VIEWED: `${appV2EventPrefix} Interview settings page viewed`,
  INTERVIEW_SETTINGS_UPDATE_SUCCESS: `${appV2EventPrefix} Interview settings updated successfully`,
  INTERVIEW_SETTINGS_UPDATE_FAILURE: `${appV2EventPrefix} Failed to update interview settings`,
  INTERVIEW_SETTINGS_PROSPECT_TOGGLE_CLICKED: `${appV2EventPrefix} Interview settings prospect toggle clicked`,

  // Interview Availability Exception
  INTERVIEW_AVAILABILITY_EXCEPTION_CREATE_SUCCESS: `${appV2EventPrefix} Interview availability exception created successfully`,
  INTERVIEW_AVAILABILITY_EXCEPTION_CREATE_FAILURE: `${appV2EventPrefix} Failed to create interview availability exception`,
  INTERVIEW_AVAILABILITY_EXCEPTION_UPDATE_SUCCESS: `${appV2EventPrefix} Interview availability exception updated successfully`,
  INTERVIEW_AVAILABILITY_EXCEPTION_UPDATE_FAILURE: `${appV2EventPrefix} Failed to update interview availability exception`,

  // Donut Delivery To Incentivize DNRs
  DONUT_DELIVERY_INFORMATION_VIEWED: `${appV2EventPrefix} Donut delivery information viewed`,
  DONUT_DELIVERY_TIME_SUBMITTED: `${appV2EventPrefix} Donut delivery time submitted`,
  CLICKED_ADDITIONAL_WORKER_AFTER_DONUT_DELIVERY_TIME_SELECTION: `${appV2EventPrefix} Clicked additional worker after donut delivery time selection`,
  WORKER_BLOCKED_AFTER_DONUT_DELIVERY_TIME_SELECTION: `${appV2EventPrefix} Worker blocked after donut delivery time selection`,

  // Facility Rules + Quiz
  FACILITY_RULE_ADDED: `${appV2EventPrefix} Facility rule added`,
  FACILITY_RULE_REMOVED: `${appV2EventPrefix} Facility rule removed`,
  FACILITY_QUIZ_QUESTION_GENERATED_FOR_RULE: `${appV2EventPrefix} Facility quiz question generated for rule`,
  FACILITY_QUIZ_QUESTION_REMOVED_FROM_RULE: `${appV2EventPrefix} Facility quiz question removed from rule`,
  FACILITY_RULES_AND_QUIZ_SAVE_CLICKED: `${appV2EventPrefix} Facility rules and quiz save clicked`,
  FACILITY_RULES_AND_QUIZ_PAGE_VIEWED: `${appV2EventPrefix} Facility rules and quiz page viewed`,

  // Worker Credentials
  CREDENTIALS_ALERT_OPENED: `${appV2EventPrefix} Credentials Alert Opened`,
  WORKER_CREDENTIAL_PROVISION_REQUEST_CREATED: `${appV2EventPrefix} Worker credential provision request created`,
  MANAGE_CREDENTIALS_MODAL_OPENED: `${appV2EventPrefix} Manage PCC credentials modal opened`,
  CREATE_OR_RESET_CREDENTIALS_MODAL_OPENED: `${appV2EventPrefix} Create or reset PCC credentials modal opened`,

  SHIFT_BOARD_PAGE_VIEWED: `${appV2EventPrefix} Shift Board page viewed`,
  SHIFT_BOARD_VIEW_DETAILS_CLICKED: `${appV2EventPrefix} Shift Board view details clicked`,

  // Shift Tracker
  SHIFT_TRACKER_VIEW_PROGRESS_CLICKED: `${appV2EventPrefix} Shift Tracker view progress clicked`,
  SHIFT_TRACKER_HIDE_PROGRESS_CLICKED: `${appV2EventPrefix} Shift Tracker hide progress clicked`,
  SHIFT_TRACKER_LEARN_MORE_CLICKED: `${appV2EventPrefix} Shift Tracker learn more clicked`,

  // Independent Contractor Badge
  INDEPENDENT_CONTRACTOR_BADGE_MODAL_OPENED: `${appV2EventPrefix} Independent contractor badge modal opened`,
  INDEPENDENT_CONTRACTOR_BADGE_GENERATED: `${appV2EventPrefix} Independent contractor badge generated`,
  INDEPENDENT_CONTRACTOR_BADGE_GENERATION_FAILED: `${appV2EventPrefix} Independent contractor badge generation failed`,
  INDEPENDENT_CONTRACTOR_BADGE_NO_MATCHING_LICENSE_FOUND: `${appV2EventPrefix} Independent contractor badge no matching license found`,

  // Unverified Placement Candidate Application
  UNVERIFIED_PLACEMENT_CANDIDATE_APPLICATION_VIEWED: `${appV2EventPrefix} Unverified placement candidate application viewed`,
  UNVERIFIED_PLACEMENT_CANDIDATE_APPLICATION_ACTION: `${appV2EventPrefix} Unverified placement candidate application action`,
  UNVERIFIED_PLACEMENT_CANDIDATE_APPLICATION_CLAIM_WORKPLACE_FORM_ACTION: `${appV2EventPrefix} Unverified placement candidate application claim workplace form action`,

  // Starred Professionals
  STARRED_PROFESSIONAL: `${appV2EventPrefix} Starred professional`,
  REMOVED_STARRED_PROFESSIONAL: `${appV2EventPrefix} Remove starred professional`,
  STARRED_PROFESSIONAL_CONFIRMATION_MODAL_OPENED: `${appV2EventPrefix} Starred professional confirmation modal opened`,
  STARRED_PROFESSIONAL_CONFIRMATION_MODAL_CANCELLED: `${appV2EventPrefix} Starred professional confirmation modal cancelled`,
  STARRED_PROFESSIONAL_ATTEMPTED_BUT_BLOCKED: `${appV2EventPrefix} Starred professional attempted but blocked`,

  // Exclusions
  UNBLOCK_WORKER: `${appV2EventPrefix} Unblock worker`,

  // Charting
  DNR_PROFESSIONAL_WITHOUT_ATTEMPTING_RECALL: `${appV2EventPrefix} DNR professional without attempting recall`,
  VISITED_CHARTING_RECALL_PAGE_INSTEAD_OF_DNR: `${appV2EventPrefix} Visited charting recall page instead of DNRing`,

  // External ID
  EXTERNAL_ID_UPDATED: `${appV2EventPrefix} External ID updated`,

  WORKPLACE_NEW_WORKER_REQUIREMENT_RATE_REQUESTED: `${appV2EventPrefix} Workplace new worker requirement rate requested`,
  WORKPLACE_NEW_WORKER_REQUIREMENT_DIALOG_VIEWED: `${appV2EventPrefix} Workplace new worker requirement dialog viewed`,
  WORKPLACE_NEW_WORKER_REQUIREMENT_RATE_REQUEST_FAILURE: `${appV2EventPrefix} Workplace new worker requirement rate request failure`,
  WORKPLACE_NEW_WORKER_REQUIREMENT_GET_REQUESTS_FAILURE: `${appV2EventPrefix} Workplace new worker requirement get requests failure`,

  // Missed Punch Request
  MISSED_PUNCH_REQUEST_TIMESHEET_BOUNDARY_VIOLATION_ATTEMPTED: `${appV2EventPrefix} Missed Punch Request Timesheet boundary violation attempted`,

  // Admin Shift Assignment
  ADMIN_SHIFT_ASSIGNMENT_WITH_OVERRIDE: `${appV2EventPrefix} Admin shift assignment with override`,
  ADMIN_SHIFT_ASSIGNMENT_WITH_OVERRIDE_ERROR: `${appV2EventPrefix} Admin shift assignment with override error`,

  // Spending Controls
  SPENDING_CONTROL_LIMIT_REACHED_MODAL_OPENED: `${appV2EventPrefix} Spending Control Limit Reached Modal Opened`,
  SPENDING_CONTROL_LIMIT_REACHED_MODAL_CLOSED: `${appV2EventPrefix} Spending Control Limit Reached Modal Closed`,
  SPENDING_CONTROL_LIMIT_REACHED_REQUEST_SUBMITTED: `${appV2EventPrefix} Spending Control Limit Reached Request Submitted`,

  SPENDING_CONTROL_INCREASE_REQUEST_DRAWER_OPENED: `${appV2EventPrefix} Spending Control Increase Request Drawer Opened`,
  SPENDING_CONTROL_INCREASE_REQUEST_SUBMITTED: `${appV2EventPrefix} Spending Control Increase Request Submitted`,

  SPENDING_CONTROL_MODAL_OPENED: `${appV2EventPrefix} Spending Control Modal Opened`,
  SPENDING_CONTROL_CREATED: `${appV2EventPrefix} Spending Control Created`,
  SPENDING_CONTROL_UPDATED: `${appV2EventPrefix} Spending Control Updated`,
  SPENDING_CONTROL_DELETED: `${appV2EventPrefix} Spending Control Deleted`,

  // Shift Notification Blast
  SHIFT_NOTIFICATION_BLAST_CREATED: `${appV2EventPrefix} Shift Notification Blast Created`,

  // Last-Minute Opt-In Variable Charge
  LAST_MINUTE_OPT_IN_VARIABLE_CHARGE_MODAL_SHOWN: `${appV2EventPrefix} Last Minute Opt In Variable Charge Modal Shown`,
  LAST_MINUTE_OPT_IN_VARIABLE_CHARGE_CONFIRMED: `${appV2EventPrefix} Last Minute Opt In Variable Charge Confirmed`,

  // Worker Cancel Report Modal
  WORKER_CANCEL_REPORT_MODAL_ACTIONED: `${appV2EventPrefix} Worker Cancel Report Modal Actioned`,

  // Evidence
  EVIDENCE_CREATED: `${appV2EventPrefix} Evidence Created`,
  EVIDENCE_UPDATE_FAILED: `${appV2EventPrefix} Evidence Update Failed`,
  HCP_DOCUMENT_V2_UPDATE_FAILED: `${appV2EventPrefix} HCP Document V2 Update Failed`,

  // Comment Reviews
  COMMENT_REVIEWS_LIST_VIEWED: `${appV2EventPrefix} Comment Reviews List Viewed`,
  COMMENT_REVIEWS_DETAIL_VIEWED: `${appV2EventPrefix} Comment Reviews Detail Viewed`,
  COMMENT_REVIEWS_APPROVED: `${appV2EventPrefix} Comment Reviews Approved`,
  COMMENT_REVIEWS_REJECTED: `${appV2EventPrefix} Comment Reviews Rejected`,

  // Push Notifications
  PUSH_NOTIFICATION_SOFT_PROMPT_SHOWN: `${appV2EventPrefix} Push notification soft prompt shown`,
  PUSH_NOTIFICATION_PERMISSION_REQUESTED: `${appV2EventPrefix} Push notification permission requested`,
  PUSH_NOTIFICATION_PERMISSION_GRANTED: `${appV2EventPrefix} Push notification permission granted`,
  PUSH_NOTIFICATION_PERMISSION_DENIED: `${appV2EventPrefix} Push notification permission denied`,
  PUSH_NOTIFICATION_REGISTERED: `${appV2EventPrefix} Push notification token registered`,
  PUSH_NOTIFICATION_RECEIVED: `${appV2EventPrefix} Push notification received`,
  PUSH_NOTIFICATION_OPENED: `${appV2EventPrefix} Push notification opened`,

  // Schedule
  SCHEDULE_VIEWED: `${appV2EventPrefix} Schedule viewed`,
  SCHEDULE_SHIFT_POSTED: `${appV2EventPrefix} Schedule shift posted`,
  SCHEDULE_SHIFT_CANCELLED: `${appV2EventPrefix} Schedule shift cancelled`,
  SCHEDULE_INVITE_SENT: `${appV2EventPrefix} Schedule invite sent`,
  SCHEDULE_BULK_SHIFTS_POSTED: `${appV2EventPrefix} Schedule bulk shifts posted`,
  SCHEDULE_BLOCK_CREATED: `${appV2EventPrefix} Schedule block created`,
  SCHEDULE_ORIENTATION_BLOCK_CREATED: `${appV2EventPrefix} Schedule orientation block created`,

  // Refer and Earn
  REFER_AND_EARN_PAGE_VIEWED: `${appV2EventPrefix} Refer And Earn Page Viewed`,
  REFER_AND_EARN_ACTION: `${appV2EventPrefix} Refer And Earn`,

  // Coverage Map
  COVERAGE_MAP_AREA_SEARCHED: `${appV2EventPrefix} Home Health coverage map area searched`,
  COVERAGE_REQUEST_SUBMITTED: `${appV2EventPrefix} Home Health coverage request submitted`,

  // External Workplace Photos (admin moderation)
  EXTERNAL_WORKPLACE_PHOTOS_LIST_VIEWED: `${appV2EventPrefix} ${EXTERNAL_WORKPLACE_PHOTOS_PREFIX} list viewed`,
  EXTERNAL_WORKPLACE_PHOTOS_PHOTO_APPROVED: `${appV2EventPrefix} ${EXTERNAL_WORKPLACE_PHOTOS_PREFIX} photo approved`,
  EXTERNAL_WORKPLACE_PHOTOS_PHOTO_REJECTED: `${appV2EventPrefix} ${EXTERNAL_WORKPLACE_PHOTOS_PREFIX} photo rejected`,
  EXTERNAL_WORKPLACE_PHOTOS_SCRAPE_TRIGGERED: `${appV2EventPrefix} ${EXTERNAL_WORKPLACE_PHOTOS_PREFIX} scrape triggered`,
};

export const APP_V2_APP_EVENTS = {
  // App
  API_SCHEMA_VALIDATION_ERROR: `${appV2EventPrefix} API Zod Schema validation error`,
  API_INPUT_SCHEMA_VALIDATION_ERROR: `${appV2EventPrefix} API Input Zod Schema validation error`,
  FEATURE_FLAG_SCHEMA_VALIDATION_ERROR: `${appV2EventPrefix} Feature Flag Zod schema validation error`,
  GET_EXTRA_WORKED_TIME_REQUESTS_FAILURE: `${appV2EventPrefix} Failed to get extra worked time request`,
  PATCH_EXTRA_WORKED_TIME_REQUESTS_FAILURE: `${appV2EventPrefix} Failed to patch extra worked time request`,
  USER_SWITCH_RELOAD: `${appV2EventPrefix} Automatically reloading the page due to user switch`,

  // Profile Change Logs
  GET_PROFILE_CHANGE_LOGS_FAILURE: `${appV2EventPrefix} Failed to get profile change logs`,

  // Documents
  GET_WORKER_DOCUMENTS_FAILURE: `${appV2EventPrefix} Failed to get hcp documents`,
  GET_DOCUMENT_DISTRIBUTION_URL_FAILURE: `${appV2EventPrefix} Failed to get document distribution URL`,
  GET_DOCUMENT_ZENDESK_TICKETS_FAILURE: `${appV2EventPrefix} Failed to get document zendesk tickets`,
  WORKER_DOCUMENTS_ACTION_FAILURE: `${appV2EventPrefix} Action failed on worker documents page`,
  UPDATE_WORKER_DOCUMENT_FAILURE: `${appV2EventPrefix} Failed to update worker document`,
  DELETE_WORKER_DOCUMENT_FAILURE: `${appV2EventPrefix} Failed to delete worker document`,
  FACILITY_BACKGROUND_CHECK_UPLOAD_FAILURE: `${appV2EventPrefix} Failed to upload background check (facility)`,
  GET_QUIZ_ATTEMPTS_DOCUMENTS_FAILURE: `${appV2EventPrefix} Failed to get quiz attempts documents`,

  // Licenses
  GET_WORKER_LICENSES_FAILURE: `${appV2EventPrefix} Failed to get worker licenses`,

  // Invoices
  GET_INVOICE_BALANCES_FAILURE: `${appV2EventPrefix} Failed to get invoice balances`,
  GET_INVOICE_HISTORY_FAILURE: `${appV2EventPrefix} Failed to get invoice history`,
  GET_INVOICE_PAYMENT_LINK: `${appV2EventPrefix} Failed to get invoice payment link`,
  GET_BILLING_SPECIALIST_FAILURE: `${appV2EventPrefix} Failed to get facility billing specialist`,
  GET_ACCOUNT_MANAGER_FAILURE: `${appV2EventPrefix} Failed to get facility account manager`,
  GET_ACCOUNT_STATEMENT_FAILURE: `${appV2EventPrefix} Failed to get account statement`,
  GET_TIMESHEET_URL: `${appV2EventPrefix} Failed to get timesheet url`,
  GET_UPCOMING_CHARGES: `${appV2EventPrefix} Failed to get upcoming charges`,
  GET_SHIFT_INVOICE: `${appV2EventPrefix} Failed to get shift invoice`,
  GET_INVOICE_FAILURE: `${appV2EventPrefix} Failed to get invoice`,
  GET_INVOICE_ITEMS_FAILURE: `${appV2EventPrefix} Failed to get invoice items`,
  GET_INVOICE_ITEM_FAILURE: `${appV2EventPrefix} Failed to get invoice item`,
  GET_INVOICE_DISPUTE_SUMMARY: `${appV2EventPrefix} Failed to get invoice dispute summary`,
  GET_INVOICE_DISPUTES_FAILURE: `${appV2EventPrefix} Failed to get invoices with disputes`,
  GET_INVOICE_TOTAL_FAILURE: `${appV2EventPrefix} Failed to get invoice total`,
  GET_INVOICE_ITEM_DISPUTES_FAILURE: `${appV2EventPrefix} Failed to get invoice item disputes`,
  GET_INVOICE_ID_FAILURE: `${appV2EventPrefix} Failed to get invoice id`,
  INVOICE_TRANSFER_FAILURE: `${appV2EventPrefix} Failed to transfer invoice`,
  INVOICE_UNVOID_FAILURE: `${appV2EventPrefix} Failed to unvoid invoice`,

  // Facility
  // TODO(clipboardhealth.atlassian.net/browse/TX-761): Remove const usage after the complete rollout and flag removal
  GET_FACILITY_SOLVE_UNPAID_WORKED_BREAKS_STAGE: `${appV2EventPrefix} Failed to load facility SolveWorkedUnpaidBreaks stage`,
  GET_WORKER_DETAILS_AT_WORKPLACE_FAILURE: `${appV2EventPrefix} Failed to get worker details at workplace`,
  GET_EXCLUSIONS_FAILURE: `${appV2EventPrefix} Failed to get exclusions`,
  DELETE_EXCLUSION_FAILURE: `${appV2EventPrefix} Failed to delete exclusion`,
  GET_EXCLUSION_CANDIDATES_FAILURE: `${appV2EventPrefix} Failed to get exclusion candidates`,
  DISMISS_EXCLUSION_CANDIDATE_FAILURE: `${appV2EventPrefix} Failed to dismiss exclusion candidate`,
  GET_EXCLUSIONS_META_FAILURE: `${appV2EventPrefix} Failed to get exclusions count`,
  COPY_EXCLUSIONS_FAILURE: `${appV2EventPrefix} Failed to copy exclusions between workplaces`,
  GET_FACILITY_NOTES_FAILURE: `${appV2EventPrefix} Failed to get facility notes`,
  GET_QUIZ_GENERATION_STATUS_FAILURE: `${appV2EventPrefix} Failed to get quiz generation status`,
  GET_FACILITY_USERS_FAILURE: `${appV2EventPrefix} Failed to get facility users`,
  GET_USER_FAILURE: `${appV2EventPrefix} Failed to get user`,
  GET_FACILITIES: `${appV2EventPrefix} Failed to get facilities`,
  GET_CHILD_WORKPLACES: `${appV2EventPrefix} Failed to get child workplaces`,
  WORKPLACE_COPY_FAILURE: `${appV2EventPrefix} Failed to copy workplace`,
  GET_WORKPLACE_FAILURE: `${appV2EventPrefix} Failed to get workplace`,
  UPDATE_FACILITY_PROFILE_REJECTED: `${appV2EventPrefix} Update facility profile rejected by API`,
  VALIDATE_CONTRACTUAL_CHARGE_RATE_FAILURE: `${appV2EventPrefix} Failed to validate contractual charge rate`,
  GET_CHARGE_RATE_LIMITS_FAILURE: `${appV2EventPrefix} Failed to get charge rate limits`,

  // Agent
  GET_PREFERRED_WORKERS_FAILURE: `${appV2EventPrefix} Failed to get preferred workers`,
  GET_AGENT_PROFILE_FAILURE: `${appV2EventPrefix} Failed to load agent profile`,
  GET_AGENT_SEARCH_FAILURE: `${appV2EventPrefix} Failed to search agent`,
  GET_OPEN_SHIFT_DATES_FAILURE: `${appV2EventPrefix} Failed to get open shift dates`,
  GET_WORKER_PAYOUT_SETTINGS_FAILURE: `${appV2EventPrefix} Failed to get worker payout settings`,
  RESYNC_PAYMENT_STATUS_WITH_STRIPE_FAILURE: `${appV2EventPrefix} Failed to resync payment status with stripe`,
  GET_WORKER_STRIPE_ACCOUNT_FAILURE: `${appV2EventPrefix} Failed to get worker stripe account`,

  // Timezone
  GET_AGENT_PROFILE_PICTURE_FAILURE: `${appV2EventPrefix} Failed to get agent profile picture`,
  GET_TIMEZONE_FAILURE: `${appV2EventPrefix} Failed to get timezone`,

  // Facility Profile
  GET_FACILITY_TIME_CARD_TEMPLATE_FAILURE: `${appV2EventPrefix} Failed to get facility time card template`,
  GET_FACILITY_PROFILE_FAILED: `${appV2EventPrefix} Failed to get facility profile`,
  UPDATE_WORKPLACE_INVALID_CONTRACT_WARNING_FAILURE: `${appV2EventPrefix} Failed to update workplace invalid contract warning settings`,
  GET_FACILITY_DETAILS_FAILURE: `${appV2EventPrefix} Failed to get facility details`,
  GET_FACILITY_DAY_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to get facility day shifts`,
  GET_FACILITY_SHIFT_COUNTS_FAILURE: `${appV2EventPrefix} Failed to get facility shift counts`,
  GET_PENDING_INVITES_FAILURE: `${appV2EventPrefix} Failed to get pending invites`,
  GET_EXPIRED_INVITES_FAILURE: `${appV2EventPrefix} Failed to get expired invites`,
  GET_WORKER_TRIPS_FAILURE: `${appV2EventPrefix} Failed to get worker trips`,
  SEND_WORKER_HOME_FAILURE: `${appV2EventPrefix} Failed to send worker home`,
  GET_SENT_HOME_PARAMS_FAILURE: `${appV2EventPrefix} Failed to get sent home params`,
  REPORT_NO_SHOW_FAILURE: `${appV2EventPrefix} Failed to report no show`,
  REPORT_WORKER_LEFT_EARLY_FAILURE: `${appV2EventPrefix} Failed to report worker left early`,
  GET_WORKER_DEPARTURE_STATUS_FAILURE: `${appV2EventPrefix} Failed to get worker departure status`,
  UPDATE_DEFAULT_SHIFT_TIMES_FAILURE: `${appV2EventPrefix} Failed to update default shift times`,
  UPDATE_PRE_SHIFT_ORIENTATION_FAILURE: `${appV2EventPrefix} Failed to update pre-shift orientation`,
  GET_AVAILABLE_WORKER_COUNT_FAILURE: `${appV2EventPrefix} Failed to get available worker count`,
  GET_AVAILABLE_WORKERS_FAILURE: `${appV2EventPrefix} Failed to get available workers`,

  // Facility User Internal Notes
  GET_FACILITY_USER_INTERNAL_NOTES_FAILURE: `${appV2EventPrefix} Failed to get facility user internal notes`,
  CREATE_FACILITY_USER_INTERNAL_NOTES_FAILURE: `${appV2EventPrefix} Failed to create facility user internal notes`,
  UPDATE_FACILITY_USER_INTERNAL_NOTES_FAILURE: `${appV2EventPrefix} Failed to update facility user internal notes`,

  // Qualifications
  GET_QUALIFICATIONS_FAILURE: `${appV2EventPrefix} Failed to get qualifications`,
  GET_QUALIFICATION_FAILURE: `${appV2EventPrefix} Failed to get qualification`,
  GET_WORKER_TYPES_FAILURE: `${appV2EventPrefix} Failed to get worker types`,

  // Skill Assessments
  GET_SKILL_ASSESSMENTS_FAILURE: `${appV2EventPrefix} Failed to get skill assessments`,

  // Workplace Types
  GET_WORKPLACE_TYPES_FAILURE: `${appV2EventPrefix} Failed to get workplace types`,
  GET_WORKPLACE_TYPE_FAILURE: `${appV2EventPrefix} Failed to get workplace type`,

  // User
  SEARCH_USERS_FAILURE: `${appV2EventPrefix} Failed to search users`,

  SEARCH_AGENTS_FAILURE: `${appV2EventPrefix} Failed to search users`,
  SEARCH_FACILITIES_FAILURE: `${appV2EventPrefix} Failed to search facilities`,
  GET_WORKPLACE_USER_ACCOUNTS_FAILURE: `${appV2EventPrefix} Failed to get workplace user accounts`,

  // Home Health
  HOME_HEALTH_ACCOUNTS_PRICING_GET_LIST_FAILURE: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} Failed to get accounts pricing list`,
  HOME_HEALTH_GET_WORKER_ENABLED_FAILURE: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} Failed to get worker enabled status`,
  HOME_HEALTH_WORKPLACE_WORKER_STATISTICS_GET_FAILURE: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} Failed to get workplace worker statistics`,
  HOME_HEALTH_GET_WORKER_WORKPLACES_FAILURE: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} Failed to get worker workplaces`,
  HOME_HEALTH_GET_WORKER_VISIT_OCCURRENCES_FAILURE: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} Failed to get worker visit occurrences`,
  HOME_HEALTH_GET_WORKER_LOG_ENTRIES_FAILURE: `${appV2EventPrefix} ${HOME_HEALTH_EVENT_PREFIX} Failed to get worker log entries`,

  // Auth
  AUTH_TOKEN_NOT_AVAILABLE: `${appV2EventPrefix} Auth token not available`,
  SIGN_IN_WITH_EMAIL_LINK_FIREBASE_FAILURE: `${appV2EventPrefix} Failed to sign in with email link via Firebase`,
  COGNITO_AUTH_REDIRECT_STARTED: `${appV2EventPrefix} Cognito auth redirect started`,
  COGNITO_AUTH_REDIRECT_COGNITO_SUCCESS: `${appV2EventPrefix} Cognito auth redirect cognito sign-in success`,
  COGNITO_AUTH_REDIRECT_SUCCESS: `${appV2EventPrefix} Cognito auth redirect success`,
  COGNITO_AUTH_REDIRECT_FAILURE: `${appV2EventPrefix} Cognito auth redirect failure`,
  COGNITO_AUTH_USER_TYPE_NOT_ALLOWED: `${appV2EventPrefix} Cognito auth user type not allowed`,
  COGNITO_MAGIC_LINK_REQUESTED: `${appV2EventPrefix} Cognito magic link requested`,
  COGNITO_PASSWORD_LOGIN_STARTED: `${appV2EventPrefix} Cognito password login started`,
  COGNITO_PASSWORD_LOGIN_COGNITO_SUCCESS: `${appV2EventPrefix} Cognito password login cognito sign-in success`,
  COGNITO_PASSWORD_LOGIN_SUCCESS: `${appV2EventPrefix} Cognito password login success`,
  COGNITO_PASSWORD_LOGIN_FAILURE: `${appV2EventPrefix} Cognito password login failure`,
  COGNITO_PASSWORD_RESET_REQUESTED: `${appV2EventPrefix} Cognito password reset requested`,
  COGNITO_PASSWORD_RESET_REQUEST_FAILURE: `${appV2EventPrefix} Cognito password reset request failure`,
  COGNITO_PASSWORD_RESET_CONFIRMED: `${appV2EventPrefix} Cognito password reset confirmed`,
  COGNITO_PASSWORD_RESET_CONFIRM_FAILURE: `${appV2EventPrefix} Cognito password reset confirm failure`,
  LOGIN_SIGNUP_LINK_CLICKED: `${appV2EventPrefix} Login signup link clicked`,
  COGNITO_AUTH_UNEXPECTED_ERROR: `${appV2EventPrefix} Cognito auth unexpected error`,
  COGNITO_PRE_SIGN_UP_REJECTED: `${appV2EventPrefix} Cognito pre-sign-up rejected`,
  COGNITO_PRE_SIGN_UP_UNEXPECTED_ERROR: `${appV2EventPrefix} Cognito pre-sign-up unexpected error`,
  SIGN_IN_WITH_CUSTOM_TOKEN_FIREBASE_FAILURE: `${appV2EventPrefix} Failed to sign in with custom token via Firebase`,
  SIGN_IN_WITH_EMAIL_PASSWORD_FIREBASE_FAILURE: `${appV2EventPrefix} Failed to sign in with email and password via Firebase`,
  PASSWORD_LOGIN_COGNITO_SESSION_SUCCESS: `${appV2EventPrefix} Password login Cognito session established`,
  PASSWORD_LOGIN_COGNITO_SESSION_FAILURE: `${appV2EventPrefix} Password login Cognito session establishment failed`,
  COGNITO_SESSION_INIT_FIREBASE_FALLBACK: `${appV2EventPrefix} Cognito session init failed, falling back to Firebase`,
  FIREBASE_FALLBACK_COGNITO_EXCHANGE_SUCCESS: `${appV2EventPrefix} Firebase fallback Cognito session exchange succeeded`,
  FIREBASE_FALLBACK_COGNITO_EXCHANGE_FAILURE: `${appV2EventPrefix} Firebase fallback Cognito session exchange failed`,
  GET_COGNITO_TOKEN_FAILURE: `${appV2EventPrefix} Get Cognito ID token failed in request interceptor`,
  RIPPLING_SSO_STARTED: `${appV2EventPrefix} Rippling SSO started`,
  RIPPLING_SSO_REDIRECT_FAILURE: `${appV2EventPrefix} Rippling SSO redirect failure`,
  RIPPLING_SSO_CALLBACK_SUCCESS: `${appV2EventPrefix} Rippling SSO callback success`,
  RIPPLING_SSO_CALLBACK_FAILURE: `${appV2EventPrefix} Rippling SSO callback failure`,
  RIPPLING_SSO_CALLBACK_RETRY: `${appV2EventPrefix} Rippling SSO callback retry`,
  RIPPLING_SSO_CALLBACK_RETRY_EXHAUSTED: `${appV2EventPrefix} Rippling SSO callback retry exhausted`,
  RIPPLING_SSO_SESSION_HYDRATION_FAILURE: `${appV2EventPrefix} Rippling SSO session hydration failure`,

  // Urgent Shifts
  SET_SHIFT_URGENT_FAILURE: `${appV2EventPrefix} Failed to set shift as urgent`,

  // Explo
  EXPLO_JWT_TOKEN_FAILURE: `${appV2EventPrefix} Explo iframe jwt token failure`,
  EXPLO_IFRAME_ERROR: `${appV2EventPrefix} Explo iframe error`,

  // Placement Candidate
  UPDATE_PLACEMENT_CANDIDATE_FAILURE: `${appV2EventPrefix} Failed to update placement candidate`,
  GET_OR_CREATE_PLACEMENT_CANDIDATE_FAILURE: `${appV2EventPrefix} Failed to get and create placement candidate`,
  GET_PLACEMENT_CANDIDATE_CREDENTIAL_URL_FAILURE: `${appV2EventPrefix} Failed to get placement candidate credential url`,
  GET_PLACEMENT_CREDENTIALS: `${appV2EventPrefix} Failed to get placement credentials`,
  ENQUEUE_PASSPORT_GENERATION_FOR_PLACEMENT_CANDIDATE_FAILURE: `${appV2EventPrefix} Failed to enqueue passport generation for a placement candidate`,

  // Placements
  PLACEMENT_CREATE_FAILURE: `${appV2EventPrefix} Placement create failure`,
  PLACEMENT_UPDATE_FAILURE: `${appV2EventPrefix} Placement update failure`,
  PLACEMENT_NOTIFY_WORKPLACE_LEAD_FAILURE: `${appV2EventPrefix} Placement notify workplace lead failure`,

  // Interviews
  GET_INTERVIEW_AVAILABILITY_FAILURE: `${appV2EventPrefix} Failed to get interview availability`,
  PLACEMENT_APPLICATION_CREATED: `${appV2EventPrefix} Placement application created`,
  PLACEMENT_APPLICATION_CREATE_FAILURE: `${appV2EventPrefix} Placement application create failure`,
  INTERVIEW_CREATED: `${appV2EventPrefix} Interview created`,
  INTERVIEW_CREATION_FAILURE: `${appV2EventPrefix} Interview creation failure`,
  UPDATE_INTERVIEW_SUCCESS: `${appV2EventPrefix} Interview updated successfully`,
  UPDATE_INTERVIEW_FAILURE: `${appV2EventPrefix} Interview update failure`,

  // Notifications
  REFRESH_NOTIFICATIONS_FAILURE: `${appV2EventPrefix} Failed to refresh braze workplace notifications`,

  // Placement Applications
  PLACEMENT_APPLICATION_UPDATE_FAILURE: `${appV2EventPrefix} Placement application update failure`,
  GET_PLACEMENT_FAILURE: `${appV2EventPrefix} Failed to get placement`,
  GET_PLACEMENT_APPLICATION_SUMMARY_FAILURE: `${appV2EventPrefix} Failed to get placement application summary`,
  PLACEMENT_APPLICATION_AUTO_INVITE_CANCEL_FAILURE: `${appV2EventPrefix} Failed to cancel placement application auto invite`,
  PLACEMENT_APPLICATION_AUTO_INVITE_SEND_FAILURE: `${appV2EventPrefix} Failed to send placement application auto invite`,
  GET_TAGS_FAILURE: `${appV2EventPrefix} Failed to get tags`,

  // Quiz
  GET_IS_QUIZ_REQUIRED_FAILURE: `${appV2EventPrefix} Failed to get if quiz is required`,
  GET_FACILITY_QUIZ_FAILURE: `${appV2EventPrefix} Failed to get workplace quiz`,

  // Booking Requests
  GET_BOOKING_REQUESTS_FAILURE: `${appV2EventPrefix} Failed to get booking requests`,
  UPDATE_BOOKING_REQUEST_FAILURE: `${appV2EventPrefix} Failed to update booking request`,

  // Support Articles
  GET_SUPPORT_ARTICLES_FAILURE: `${appV2EventPrefix} Failed to get support articles`,

  // Access Window
  GET_ACCESS_WINDOW_FAILURE: `${appV2EventPrefix} Failed to get access window for a unfilled shift`,

  // Nearby Workers
  GET_NEARBY_WORKERS_FAILURE: `${appV2EventPrefix} Failed to get nearby workers`,

  // Requirement
  GET_REQUIREMENT_FAILURE: `${appV2EventPrefix} Failed to get requirement`,
  GET_REQUIREMENTS_FAILURE: `${appV2EventPrefix} Failed to get requirements`,
  GET_PREREQUISITE_ACTIONS_FAILURE: `${appV2EventPrefix} Failed to get prerequisite actions`,

  // Counties
  GET_COUNTIES_FAILURE: `${appV2EventPrefix} Failed to get counties`,

  // MSA
  GET_MSAS_FAILURE: `${appV2EventPrefix} Failed to get MSAs`,

  // Zendesk Document Processor
  ZENDESK_DOCUMENT_PROCESSOR_UPDATE_DOCUMENT_ERROR: `${appV2EventPrefix} ${ZENDESK_DOCUMENT_PROCESSOR_PREFIX} Update Document Error`,
  ZENDESK_DOCUMENT_PROCESSOR_DOCUMENT_REJECTED: `${appV2EventPrefix} ${ZENDESK_DOCUMENT_PROCESSOR_PREFIX} Document Rejected`,
  ZENDESK_DOCUMENT_PROCESSOR_DOCUMENT_APPROVED: `${appV2EventPrefix} ${ZENDESK_DOCUMENT_PROCESSOR_PREFIX} Document Approved`,
  ZENDESK_DOCUMENT_PROCESSOR_DOCUMENT_VIEW_OPENED: `${appV2EventPrefix} ${ZENDESK_DOCUMENT_PROCESSOR_PREFIX} Document View Opened`,
  ZENDESK_DOCUMENT_PROCESSOR_UPDATE_LICENSE_ERROR: `${appV2EventPrefix} ${ZENDESK_DOCUMENT_PROCESSOR_PREFIX} Update License Error`,
  ZENDESK_DOCUMENT_PROCESSOR_LICENSE_ACTION: `${appV2EventPrefix} ${ZENDESK_DOCUMENT_PROCESSOR_PREFIX} License View Action`,
  ZENDESK_DOCUMENT_PROCESSOR_ADD_REQUIREMENT: `${appV2EventPrefix} ${ZENDESK_DOCUMENT_PROCESSOR_PREFIX} Add Requirement`,

  // Agent Drawer Document Review
  AGENT_DRAWER_DOCUMENT_APPROVED: `${appV2EventPrefix} ${AGENT_DRAWER_DOCUMENT_REVIEW_PREFIX} Document Approved`,
  AGENT_DRAWER_DOCUMENT_REJECTED: `${appV2EventPrefix} ${AGENT_DRAWER_DOCUMENT_REVIEW_PREFIX} Document Rejected`,
  AGENT_DRAWER_DOCUMENT_MARKED_PENDING: `${appV2EventPrefix} ${AGENT_DRAWER_DOCUMENT_REVIEW_PREFIX} Document Marked Pending`,

  NON_EXISTING_ICON_REQUESTED: `${appV2EventPrefix} Non existing icon requested`,

  // Chat Channel
  POST_CREATE_CHAT_CHANNEL_FAILURE: `${appV2EventPrefix} Failed to create the channel`,
  CHANNEL_PREVIEW_MISSING_URL: `${appV2EventPrefix} Channel preview missing channel URL`,
  MARK_CHAT_AS_UNREAD_FAILURE: `${appV2EventPrefix} Failed to mark chat channel as unread`,

  // Chat Message Parsing
  EXTRACT_FACILITY_CANCELED_ME_MESSAGE_NAME_FAILURE: `${appV2EventPrefix} Failed to extract name from facility canceled me message`,
  EXTRACT_FACILITY_CANCELED_ME_MESSAGE_REASON_FAILURE: `${appV2EventPrefix} Failed to extract reason from facility canceled me message`,
  EXTRACT_MESSAGE_DATA_FAILURE: `${appV2EventPrefix} Failed to parse message data`,
  EXTRACT_GROUP_SHIFT_INVITES_QUANTITY_FAILURE: `${appV2EventPrefix} Failed to extract number of shift invites from message`,

  // Chat Message Render Failures
  SHIFT_INVITE_REQUEST_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render shift invite request message`,
  SHIFT_TIME_PROPOSAL_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render shift time proposal message`,
  VISIT_INVITE_REQUEST_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render visit invite request message`,
  PLACEMENT_APPLICATION_SUGGEST_INTERVIEW_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render placement application suggest interview message`,
  PLACEMENT_APPLICATION_AUTO_INTERVIEW_INVITE_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render placement application auto interview invite message`,
  REVIEW_SENT_HOME_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render review sent home message`,

  // Shift Signing Out
  CREATE_SHIFT_SIGNING_OUT_FEEDBACK_FAILURE: `${appV2EventPrefix} Error while trying to create shift signing out feedback`,
  UPLOAD_SIGNER_SIGNATURE_FAILURE: `${appV2EventPrefix} Error while trying to upload feedback signer signature`,
  QR_CODE_SIGNATURE_SUBMIT_TIME_SHEET_FAILURE: `${appV2EventPrefix} Error while trying to submit shift time sheet with QR code signature`,
  SHIFT_SIGNING_OUT_FEEDBACK_SUBMIT_FAILURE: `${appV2EventPrefix} Error on finalizing shift signing out feedback`,

  // Shift
  GET_SHIFT_FAILURE: `${appV2EventPrefix} Failed to get shift`,
  GET_SHIFT_STATE_FAILURE: `${appV2EventPrefix} Failed to get shift state`,
  GET_SHIFTS_LIST_FAILURE: `${appV2EventPrefix} Failed to get shifts`,
  GET_ADMIN_OPEN_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to get admin open shifts`,
  CREATE_SHIFT_FAILURE: `${appV2EventPrefix} Failed to create shift`,
  CREATE_SHIFT_MIGRATION_FAILURE: `${appV2EventPrefix} Failed to create shift migration`,
  DELETE_SHIFT_FAILURE: `${appV2EventPrefix} Failed to delete shift`,
  UPDATE_SHIFT_TIME_FAILURE: `${appV2EventPrefix} Failed to update shift time`,
  UPDATE_SHIFT_SPECIFICATIONS_FAILURE: `${appV2EventPrefix} Failed to update shift specifications`,

  // Shift Invite
  GET_SHIFT_INVITE_FAILURE: `${appV2EventPrefix} Failed to get shift invite`,

  // FCM (Facility Canceled Me / Sent Home) Request
  FCM_REQUEST_APPROVE_FAILURE: `${appV2EventPrefix} Failed to approve FCM request`,
  FCM_REQUEST_REJECT_FAILURE: `${appV2EventPrefix} Failed to reject FCM request`,
  FCM_REQUEST_CONFIRMATION_SUBMITTED: `${appV2EventPrefix} Facility Cancelled Me Confirmation Submitted`,

  // Agreements
  GET_SIGNED_AGREEMENTS_FAILURE: `${appV2EventPrefix} Failed to get signed agreements`,

  // Shift Signout Flow
  GET_SHIFT_FEEDBACK_FAILURE: `${appV2EventPrefix} Failed to get shift feedback`,

  // Worker Left Early
  GET_WORKER_LEFT_EARLY_FAILURE: `${appV2EventPrefix} Failed to get worker left early`,

  // Charting
  GET_CHARTING_COMPLETION_REPORTS_FAILURE: `${appV2EventPrefix} Failed to get charting completion reports`,
  GET_CHARTING_NONCOMPLIANCES_FAILURE: `${appV2EventPrefix} Failed to get charting noncompliances`,
  GET_WORKPLACE_CHARTING_NONCOMPLIANCES_FAILURE: `${appV2EventPrefix} Failed to get workplace charting noncompliances`,

  // Worker Credentials
  GET_WORKER_CREDENTIALS_FOR_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to get worker credentials for shifts`,
  GET_WORKER_CREDENTIAL_PROVISION_REQUEST_FAILURE: `${appV2EventPrefix} Failed to get worker credential provision request`,
  CREATE_WORKER_CREDENTIAL_PROVISION_REQUEST_FAILURE: `${appV2EventPrefix} Failed to create worker credential provision request`,
  CREATE_WORKER_CREDENTIAL_PROVISION_REQUEST_SUCCESS: `${appV2EventPrefix} Worker credential provision request created successfully`,
  QUALIFICATION_NOT_PROVISIONABLE_FAILURE: `${appV2EventPrefix} Qualification is not provisionable`,
  WORKER_CREDENTIAL_PROVISIONED_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render worker credential provisioned message`,
  WORKER_CREDENTIAL_PROVISION_REQUEST_NO_RESPONSE_FAILURE: `${appV2EventPrefix} Failed to get response from credential provision request`,

  // Independent Contractor Badge
  INDEPENDENT_CONTRACTOR_BADGE_OPENED_IN_NEW_TAB: `${appV2EventPrefix} Independent contractor badge opened in new tab`,
  INDEPENDENT_CONTRACTOR_BADGE_GENERATION_FAILURE: `${appV2EventPrefix} Failed to generate independent contractor badge`,
  INDEPENDENT_CONTRACTOR_BADGE_SETTING_UPDATE_FAILURE: `${appV2EventPrefix} Failed to update independent contractor badge setting`,
  INDEPENDENT_CONTRACTOR_BADGES_FETCH_FAILURE: `${appV2EventPrefix} Failed to fetch contractor badges`,
  INDEPENDENT_CONTRACTOR_BADGE_FETCH_IMAGE_FAILURE: `${appV2EventPrefix} Failed to fetch independent contractor badge image`,
  INDEPENDENT_CONTRACTOR_BADGE_GENERATION_PDF_FAILURE: `${appV2EventPrefix} Failed to generate independent contractor badge pdf`,
  INDEPENDENT_CONTRACTOR_BADGE_DOWNLOAD_FAILURE: `${appV2EventPrefix} Failed to download independent contractor badge pdf`,
  WORKPLACE_BADGE_REQUEST_WITHOUT_APPROVED_PHOTO: `${appV2EventPrefix} Workplace badge request without approved photo`,

  // Shift Charge
  GET_ESTIMATED_CHARGE_FAILURE: `${appV2EventPrefix} Failed to get estimated charge`,

  // Shift Qualification Pricing Settings
  GET_SHIFT_QUALIFICATION_PRICING_SETTINGS_FAILURE: `${appV2EventPrefix} Failed to get shift qualification pricing settings`,

  // Shoppable Qualifications
  GET_WORKER_SHOPPABLE_QUALIFICATIONS_FAILURE: `${appV2EventPrefix} Failed to get worker shoppable qualifications`,
  CREATE_WORKER_SHOPPABLE_QUALIFICATION_FAILURE: `${appV2EventPrefix} Failed to create worker shoppable qualification`,
  DELETE_WORKER_SHOPPABLE_QUALIFICATION_FAILURE: `${appV2EventPrefix} Failed to delete worker shoppable qualification`,

  // Starred Professionals
  GET_WORKPLACE_STARRED_PROFESSIONALS_FAILURE: `${appV2EventPrefix} Failed to get workplace starred professionals`,
  POST_WORKPLACE_STARRED_PROFESSIONAL_FAILURE: `${appV2EventPrefix} Failed to post workplace starred professional`,
  DELETE_WORKPLACE_STARRED_PROFESSIONAL_FAILURE: `${appV2EventPrefix} Failed to delete workplace starred professional`,

  // Guest Placement Application
  GET_GUEST_PLACEMENT_APPLICATION_FAILURE: `${appV2EventPrefix} Failed to get guest placement application`,

  // Claim Workplace Placement
  CLAIM_WORKPLACE_PLACEMENT_FAILURE: `${appV2EventPrefix} Failed to claim workplace placement`,

  // Shift Explainer
  GET_SHIFT_BOOKABILITY_STATUS_FAILURE: `${appV2EventPrefix} Failed to get shift bookability status`,

  // Workplace Agreements
  GET_WORKPLACE_AGREEMENTS_FAILURE: `${appV2EventPrefix} Failed to get workplace agreements`,
  CREATE_WORKPLACE_AGREEMENT_FAILURE: `${appV2EventPrefix} Failed to create workplace agreement`,
  CREATE_WORKPLACE_AGREEMENT_SUCCESS: `${appV2EventPrefix} Created workplace agreement successfully`,

  // Orientation Blocks
  GET_ORIENTATION_BLOCK_FAILURE: `${appV2EventPrefix} Failed to get orientation block`,
  DELETE_ORIENTATION_BLOCK_FAILURE: `${appV2EventPrefix} Failed to delete orientation block`,

  // Single Orientation Shifts
  CREATE_ORIENTATION_SHIFT_FAILURE: `${appV2EventPrefix} Failed to create orientation shift`,

  // External integration sync
  EXTERNAL_INTEGRATION_SHIFT_FACILITY_FAILURE: `${appV2EventPrefix} Failed to trigger historical shift sync due to a missing facility`,

  // Workplace external integration
  CREATE_WORKPLACE_EXTERNAL_INTEGRATION_FAILURE: `${appV2EventPrefix} Failed to create workplace external integration`,
  UPDATE_WORKPLACE_EXTERNAL_INTEGRATION_FAILURE: `${appV2EventPrefix} Failed to update workplace external integration`,

  // Coverage Map
  COVERAGE_MAP_PAGE_VIEWED: `${appV2EventPrefix} Home Health coverage map page viewed`,
  GET_COVERAGE_MAP_VISIT_OCCURRENCES_FAILURE: `${appV2EventPrefix} Failed to get coverage map visit occurrences`,
  COVERAGE_MAP_VISUALIZATION_LIBRARY_LOAD_FAILURE: `${appV2EventPrefix} Coverage map visualization library failed to load`,

  // Spending Controls
  GET_SPENDING_CONTROLS_FAILURE: `${appV2EventPrefix} Failed to get spending controls`,
  CREATE_SPENDING_CONTROL_FAILURE: `${appV2EventPrefix} Failed to create spending control`,
  CREATE_SPENDING_CONTROL_NOTIFICATION_FAILURE: `${appV2EventPrefix} Failed to create spending control notification`,
  VALIDATE_SPENDING_CONTROL_FAILURE: `${appV2EventPrefix} Failed to validate spending control`,

  // Slack Notifications
  SEND_WORKER_CANCEL_ALERT_FAILURE: `${appV2EventPrefix} Failed to send worker cancel alert to Slack`,

  // Rate negotiations
  UNABLE_TO_ACCEPT_NEGOTIATION: `${appV2EventPrefix} Unable to accept negotiation`,
  UNABLE_TO_ACCEPT_NEGOTIATION_DUE_TO_BACKGROUND_CHECK_BEING_DELAYED: `${appV2EventPrefix} Unable to accept negotiation due to background check being delayed`,
  UNABLE_TO_ACCEPT_NEGOTIATION_DUE_TO_NO_VALID_BACKGROUND_CHECK_WITH_SHIFT_STARTING_SOON: `${appV2EventPrefix} Unable to accept negotiation due to no valid background check with shift starting soon`,
  GET_NEGOTIATION_CHARGE_BREAKDOWN_FAILURE: `${appV2EventPrefix} Failed to get negotiation charge breakdown`,
  GET_NEGOTIATIONS_FAILURE: `${appV2EventPrefix} Failed to get negotiations`,

  // Badge Verification Grading
  GET_BADGE_VERIFICATIONS_FAILURE: `${appV2EventPrefix} Failed to get badge verifications`,
  GET_BADGE_VERIFICATION_PHOTO_URL_FAILURE: `${appV2EventPrefix} Failed to get badge verification photo URL`,
  GRADE_BADGE_VERIFICATION_FAILURE: `${appV2EventPrefix} Failed to grade badge verification`,
  DELETE_BADGE_VERIFICATION_FAILURE: `${appV2EventPrefix} Failed to delete badge verification`,

  // Shift Notification Blast
  CREATE_SHIFT_NOTIFICATION_BLAST_FAILURE: `${appV2EventPrefix} Failed to create shift notification blast`,

  // Bonus Payment
  PAY_HCP_BONUS_MISSING_IDEMPOTENCY_KEY: `${appV2EventPrefix} Idempotency key not found when submitting bonus payment`,

  // Missed Punch Request
  SUBMIT_UNSIGNED_MPR_SUCCESS: `${appV2EventPrefix} Unsigned missed punch request submitted successfully`,
  SUBMIT_UNSIGNED_MPR_FAILURE: `${appV2EventPrefix} Failed to submit unsigned missed punch request`,

  // In-Home Lock
  GET_WORKER_LOCK_STATUS_FAILURE: `${appV2EventPrefix} Failed to get worker lock status`,
  CREATE_WORKER_LOCK_FAILURE: `${appV2EventPrefix} Failed to create worker lock`,
  DELETE_WORKER_LOCK_FAILURE: `${appV2EventPrefix} Failed to delete worker lock`,

  // Evidence
  GET_EVIDENCE_DEFINITIONS_FAILURE: `${appV2EventPrefix} Failed to get evidence definitions`,
  GET_WORKER_EVIDENCES_FAILURE: `${appV2EventPrefix} Failed to get worker evidences`,
  CREATE_EVIDENCE_FAILURE: `${appV2EventPrefix} Failed to create evidence`,
  UPDATE_EVIDENCE_FAILURE: `${appV2EventPrefix} Failed to update evidence`,
  GET_DOCUMENT_EVIDENCES_FAILURE: `${appV2EventPrefix} Failed to get document evidences`,
  GET_WORKER_NAME_FAILURE: `${appV2EventPrefix} Failed to get worker name`,

  // 1099 Policy
  GET_TEN99_POLICY_CONFIGURATION_FAILURE: `${appV2EventPrefix} Failed to get 1099 policy configuration`,
  CREATE_TEN99_POLICY_ENTITY_FAILURE: `${appV2EventPrefix} Failed to create 1099 policy entity`,
  CREATE_TEN99_POLICY_REQUIREMENT_MAPPING_FAILURE: `${appV2EventPrefix} Failed to create 1099 policy requirement mapping`,

  // Eligibility
  GET_V2_REQUIREMENTS_FAILURE: `${appV2EventPrefix} Failed to get v2 requirements`,
  SEARCH_V2_REQUIREMENTS_FAILURE: `${appV2EventPrefix} Failed to search v2 requirements`,
  CREATE_V2_REQUIREMENT_FAILURE: `${appV2EventPrefix} Failed to create v2 requirement`,
  UPDATE_V2_REQUIREMENT_FAILURE: `${appV2EventPrefix} Failed to update v2 requirement`,
  DELETE_V2_REQUIREMENT_FAILURE: `${appV2EventPrefix} Failed to delete v2 requirement`,
  GET_V2_REQUIREMENT_MAPPINGS_FAILURE: `${appV2EventPrefix} Failed to get v2 requirement mappings`,
  CREATE_V2_REQUIREMENT_MAPPING_FAILURE: `${appV2EventPrefix} Failed to create v2 requirement mapping`,
  UPDATE_V2_REQUIREMENT_MAPPING_FAILURE: `${appV2EventPrefix} Failed to update v2 requirement mapping`,
  DELETE_V2_REQUIREMENT_MAPPING_FAILURE: `${appV2EventPrefix} Failed to delete v2 requirement mapping`,
  GET_WORKPLACE_REQUIREMENTS_FAILURE: `${appV2EventPrefix} Failed to get workplace requirements`,
  GET_WORKPLACE_REQUIREMENTS_PAGES_FETCHED: `${appV2EventPrefix} Workplace requirements pages fetched`,
  CREATE_FLAG_REQUIREMENT_FAILURE: `${appV2EventPrefix} Failed to create flag requirement`,
  GET_TEMPLATE_PDF_DISTRIBUTION_URL_FAILURE: `${appV2EventPrefix} Failed to get template PDF distribution URL`,
  GET_V2_STANDARDS_FAILURE: `${appV2EventPrefix} Failed to get v2 standards`,
  CREATE_V2_STANDARD_FAILURE: `${appV2EventPrefix} Failed to create v2 standard`,
  UPDATE_V2_STANDARD_FAILURE: `${appV2EventPrefix} Failed to update v2 standard`,
  DELETE_V2_STANDARD_FAILURE: `${appV2EventPrefix} Failed to delete v2 standard`,
  GET_V2_EVIDENCE_DEFINITIONS_FAILURE: `${appV2EventPrefix} Failed to get v2 evidence definitions`,
  SEARCH_V2_EVIDENCE_DEFINITIONS_FAILURE: `${appV2EventPrefix} Failed to search v2 evidence definitions`,
  CREATE_V2_EVIDENCE_DEFINITION_FAILURE: `${appV2EventPrefix} Failed to create v2 evidence definition`,
  UPDATE_V2_EVIDENCE_DEFINITION_FAILURE: `${appV2EventPrefix} Failed to update v2 evidence definition`,
  DELETE_V2_EVIDENCE_DEFINITION_FAILURE: `${appV2EventPrefix} Failed to delete v2 evidence definition`,

  // Push Notifications
  UPDATE_PUSH_TOKEN_FAILURE: `${appV2EventPrefix} Failed to update push token`,
  PUSH_NOTIFICATION_REGISTRATION_ERROR: `${appV2EventPrefix} Push notification registration error`,
  PUSH_NOTIFICATION_LISTENER_SETUP_FAILURE: `${appV2EventPrefix} Push notification listener setup failure`,
  BRAZE_PUSH_SYNC_FAILURE: `${appV2EventPrefix} Braze push sync failure`,

  // Live Update
  LIVE_UPDATE_READY: `${appV2EventPrefix} Live update ready`,
  LIVE_UPDATE_ROLLBACK: `${appV2EventPrefix} Live update rolled back`,
  LIVE_UPDATE_READY_FAILURE: `${appV2EventPrefix} Live update ready failed`,

  // Comment Reviews
  GET_WORKPLACE_COMMENTS_FAILURE: `${appV2EventPrefix} Failed to get workplace comments`,
  UPDATE_COMMENT_FLAG_FAILURE: `${appV2EventPrefix} Failed to update comment flag`,

  // Reporting
  GET_LIFETIME_SHIFT_COUNT_FAILURE: `${appV2EventPrefix} Failed to get lifetime shift count`,
  GET_LIFETIME_STAFF_COUNT_FAILURE: `${appV2EventPrefix} Failed to get lifetime staff count`,
  GET_UPCOMING_SHIFT_COUNTS_FAILURE: `${appV2EventPrefix} Failed to get upcoming shift counts`,
  GET_UPCOMING_SHIFTS_PAGE_FAILURE: `${appV2EventPrefix} Failed to get upcoming shifts page`,
  GET_WORKPLACE_STATISTICS_FAILURE: `${appV2EventPrefix} Failed to get workplace statistics`,
  REQUEST_PAST_SHIFTS_REPORT_FAILURE: `${appV2EventPrefix} Failed to request past shifts report`,
  UPDATE_WORKER_CREDENTIAL_CONFIGURATION_FAILURE: `${appV2EventPrefix} Failed to update worker credential configuration`,

  // Refer and Earn
  GET_REFERRAL_CODE_FAILURE: `${appV2EventPrefix} Failed to get referral code`,
  GET_REFERRAL_USAGE_FAILURE: `${appV2EventPrefix} Failed to get referral usage`,

  // SMS Portal
  SMS_PORTAL_FETCH_WORKPLACE_USERS_FAILURE: `${appV2EventPrefix} Failed to fetch workplace users for SMS Portal`,
  SMS_PORTAL_FETCH_CONVERSATION_MESSAGES_FAILURE: `${appV2EventPrefix} Failed to fetch conversation messages`,
  SMS_PORTAL_SEND_MESSAGE_FAILURE: `${appV2EventPrefix} Failed to send SMS message`,
  SMS_PORTAL_FETCH_FACILITY_PROFILE_FAILURE: `${appV2EventPrefix} Failed to fetch facility profile for SMS Portal`,

  // My Account
  GET_CURRENT_USER_FAILURE: `${appV2EventPrefix} Failed to get current user`,
  UPDATE_PERSONAL_INFO_FAILURE: `${appV2EventPrefix} Failed to update personal information`,
  DEACTIVATE_USER_FAILURE: `${appV2EventPrefix} Failed to deactivate user`,
  UNLINK_USER_FAILURE: `${appV2EventPrefix} Failed to unlink user`,

  // Last-Minute Opt-In Variable Charge
  LAST_MINUTE_OPT_IN_VARIABLE_CHARGE_BLAST_FAILED: `${appV2EventPrefix} Last Minute Opt In Variable Charge blast failed after shift create`,

  // FCF Unbooked Shift Swap
  FCF_CANCEL_SHIFT_CLICKED: `${appV2EventPrefix} FCF cancel shift clicked`,
  FCF_UNBOOKED_SWAP_MODAL_SHOWN: `${appV2EventPrefix} FCF Unbooked Swap modal shown`,
  FCF_UNBOOKED_SWAP_MODAL_DISMISSED: `${appV2EventPrefix} FCF Unbooked Swap modal dismissed`,
  FCF_UNBOOKED_SWAP_APPROVED: `${appV2EventPrefix} FCF Unbooked Swap approved`,
  FCF_UNBOOKED_SWAP_REMOVE_WORKER_CLICKED: `${appV2EventPrefix} FCF Unbooked Swap remove worker clicked`,
  FCF_DNR_SWAP_MODAL_SHOWN: `${appV2EventPrefix} FCF DNR Swap modal shown`,
  FCF_DNR_SWAP_MODAL_DISMISSED: `${appV2EventPrefix} FCF DNR Swap modal dismissed`,
  FCF_DNR_SWAP_DNR_CLICKED: `${appV2EventPrefix} FCF DNR Swap DNR clicked`,
  FCF_DNR_SWAP_DELETE_SHIFT_CLICKED: `${appV2EventPrefix} FCF DNR Swap delete shift clicked`,

  // Bulk posting
  BULK_POSTING_DRAFT_PARSE_FAILURE: `${appV2EventPrefix} Failed to parse persisted bulk-posting draft`,
  BULK_POSTING_DRAFT_STORAGE_FAILURE: `${appV2EventPrefix} Failed to access localStorage for bulk-posting draft`,

  // Block booking
  BLOCK_BOOKING_DRAFT_PARSE_FAILURE: `${appV2EventPrefix} Failed to parse persisted block-booking draft`,
  BLOCK_BOOKING_DRAFT_STORAGE_FAILURE: `${appV2EventPrefix} Failed to access localStorage for block-booking draft`,

  // Knock
  KNOCK_PUSH_TOKEN_REGISTERED: `${appV2EventPrefix} Knock push token registered`,
  KNOCK_PUSH_TOKEN_REGISTRATION_FAILED: `${appV2EventPrefix} Knock push token registration failed`,
  KNOCK_PUSH_TOKEN_UNREGISTERED: `${appV2EventPrefix} Knock push token unregistered`,
  KNOCK_PUSH_TOKEN_UNREGISTRATION_FAILED: `${appV2EventPrefix} Knock push token unregistration failed`,
  KNOCK_MESSAGE_STATUS_UPDATED: `${appV2EventPrefix} Knock message status updated`,
  KNOCK_MESSAGE_STATUS_UPDATE_FAILED: `${appV2EventPrefix} Knock message status update failed`,
  KNOCK_TOKEN_REFRESH_REQUESTED: `${appV2EventPrefix} Knock token refresh requested`,
  KNOCK_TOKEN_REFRESH_FAILED: `${appV2EventPrefix} Knock token refresh failed`,
  KNOCK_GUIDES_REFETCH_ON_VISIBLE_FAILED: `${appV2EventPrefix} Knock guides refetch on visible failed`,
  KNOCK_GUIDE_ACTION_NOT_HANDLED: `${appV2EventPrefix} Knock guide action not handled`,
  KNOCK_BROWSER_OPEN_FAILED: `${appV2EventPrefix} Knock browser open failed`,
  KNOCK_COMPONENT_ERROR_BOUNDARY: `${appV2EventPrefix} Knock component error boundary`,

  // PRN Roster
  GET_PRN_WORKERS_FAILURE: `${appV2EventPrefix} Failed to get PRN workers`,
  CREATE_PRN_WORKER_FAILURE: `${appV2EventPrefix} Failed to create PRN worker`,
  UPDATE_PRN_WORKER_FAILURE: `${appV2EventPrefix} Failed to update PRN worker`,
  DELETE_PRN_WORKER_FAILURE: `${appV2EventPrefix} Failed to delete PRN worker`,
  CREATE_PRN_SHIFT_POSTING_FAILURE: `${appV2EventPrefix} Failed to create PRN shift posting`,
  GET_PRN_SHIFT_POSTINGS_FAILURE: `${appV2EventPrefix} Failed to get PRN shift postings`,
  DELETE_PRN_SHIFT_POSTING_FAILURE: `${appV2EventPrefix} Failed to delete PRN shift posting`,

  // External Workplace Photos (admin moderation)
  GET_EXTERNAL_WORKPLACE_PHOTOS_FAILURE: `${appV2EventPrefix} ${EXTERNAL_WORKPLACE_PHOTOS_PREFIX} failed to get photos`,
  GET_EXTERNAL_WORKPLACE_PHOTO_SCRAPING_JOBS_FAILURE: `${appV2EventPrefix} ${EXTERNAL_WORKPLACE_PHOTOS_PREFIX} failed to get scraping jobs`,
  UPDATE_EXTERNAL_WORKPLACE_PHOTO_FAILURE: `${appV2EventPrefix} ${EXTERNAL_WORKPLACE_PHOTOS_PREFIX} failed to update photo`,
  CREATE_EXTERNAL_WORKPLACE_PHOTO_SCRAPING_JOB_FAILURE: `${appV2EventPrefix} ${EXTERNAL_WORKPLACE_PHOTOS_PREFIX} failed to create scraping job`,
  LIST_EXTERNAL_PHOTO_PENDING_WORKPLACES_FAILURE: `${appV2EventPrefix} ${EXTERNAL_WORKPLACE_PHOTOS_PREFIX} failed to list pending workplaces`,
};

export const SHIFT_TIME_PROPOSAL_EVENTS = {
  SHIFT_TIME_PROPOSAL_CREATED: `${appV2EventPrefix} ${SHIFT_TIME_PROPOSALS_PREFIX} proposal created`,
  SHIFT_TIME_PROPOSAL_UPDATED: `${appV2EventPrefix} ${SHIFT_TIME_PROPOSALS_PREFIX} proposal updated`,
};
